import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { App } from '../shared/App';
import './webcomponents/razem-toast';

const doHydrate = async () => {
  try {
    const container = document.getElementById('root') as HTMLElement;
    const url = new URL(location.href);
    url.searchParams.set('props', '1');
    const propsRequest = await fetch(url.toString());
    const props = await propsRequest.json();
    hydrateRoot(container, <App {...props} />);
  } catch (error) {
    console.error('Could not hydrate', error);
  }
};

doHydrate();
